import { ReportProfileDelegate } from '../profile/report-profile-delegate';

export class ReportProfileDelegateAccess extends ReportProfileDelegate {
  lastAccess: Date;
}
